import * as React from "react";
import "./iconStyle.scss";

const PHONE_CALLING = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <defs>
            <path
                id="a"
                d="M14.204 5.372a.5.5 0 1 1 .192-.982 5.976 5.976 0 0 1 4.721 4.721.5.5 0 0 1-.981.192 4.976 4.976 0 0 0-3.932-3.931zm.54-4.375a.5.5 0 1 1 .111-.994 10.357 10.357 0 0 1 9.15 9.137.5.5 0 0 1-.995.112A9.357 9.357 0 0 0 14.745.997zm8.038 20.223a2.69 2.69 0 0 1-2.941 2.69 22.17 22.17 0 0 1-9.666-3.438 21.852 21.852 0 0 1-6.723-6.721A22.182 22.182 0 0 1 .01 4.028a2.69 2.69 0 0 1 2.677-2.933H5.97A2.692 2.692 0 0 1 8.66 3.414 13.56 13.56 0 0 0 9.4 6.38c.369.983.133 2.091-.608 2.84L7.674 10.34a17.024 17.024 0 0 0 5.864 5.864l1.12-1.12a2.69 2.69 0 0 1 2.838-.606c.958.357 1.954.606 2.972.74a2.69 2.69 0 0 1 2.314 2.724v3.278zm-1-3.284a1.693 1.693 0 0 0-1.449-1.727 14.565 14.565 0 0 1-3.188-.795 1.69 1.69 0 0 0-1.782.379l-1.39 1.39a.5.5 0 0 1-.601.082 18.024 18.024 0 0 1-6.76-6.76.5.5 0 0 1 .082-.6l1.389-1.389a1.69 1.69 0 0 0 .38-1.784 14.551 14.551 0 0 1-.793-3.183 1.692 1.692 0 0 0-1.696-1.454H2.69A1.69 1.69 0 0 0 1.006 3.93a21.18 21.18 0 0 0 3.287 9.28 20.863 20.863 0 0 0 6.422 6.42 21.167 21.167 0 0 0 9.225 3.285 1.69 1.69 0 0 0 1.842-1.693v-3.286z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="none" fillOpacity="0" d="M0 0h24v24H0z" />
            <mask id="b" fill="#0498B4">
                <use xlinkHref="#a" />
            </mask>
            <use fill="#888888" fillRule="nonzero" xlinkHref="#a" />
            <g fill="#888888" mask="url(#b)">
                <path d="M0 0h24v24H0z" />
            </g>
        </g>
    </svg>
);

const PHONE_PENDING = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <defs>
            <path
                id="pending"
                d="M23.011 1.696L16.187 8.52a.5.5 0 0 1-.707-.707L22.293 1H16.94a.5.5 0 0 1 0-1h6.571a.5.5 0 0 1 .5.5v6.571a.5.5 0 1 1-1 0V1.696zm-.229 19.524a2.69 2.69 0 0 1-2.941 2.69 22.17 22.17 0 0 1-9.666-3.438 21.852 21.852 0 0 1-6.723-6.721A22.182 22.182 0 0 1 .01 4.028a2.69 2.69 0 0 1 2.677-2.933H5.97A2.692 2.692 0 0 1 8.66 3.414 13.56 13.56 0 0 0 9.4 6.38c.369.983.133 2.091-.608 2.84L7.674 10.34a17.024 17.024 0 0 0 5.864 5.864l1.12-1.12a2.69 2.69 0 0 1 2.838-.606c.958.357 1.954.606 2.972.74a2.69 2.69 0 0 1 2.314 2.724v3.278zm-1-3.284a1.693 1.693 0 0 0-1.449-1.727 14.565 14.565 0 0 1-3.188-.795 1.69 1.69 0 0 0-1.782.379l-1.39 1.39a.5.5 0 0 1-.601.082 18.024 18.024 0 0 1-6.76-6.76.5.5 0 0 1 .082-.6l1.389-1.389a1.69 1.69 0 0 0 .38-1.784 14.551 14.551 0 0 1-.793-3.183 1.692 1.692 0 0 0-1.696-1.454H2.69A1.69 1.69 0 0 0 1.006 3.93a21.18 21.18 0 0 0 3.287 9.28 20.863 20.863 0 0 0 6.422 6.42 21.167 21.167 0 0 0 9.225 3.285 1.69 1.69 0 0 0 1.842-1.693v-3.286z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="none" fillOpacity="0" d="M0 0h24v24H0z" />
            <mask id="mask-close" fill="#0498B4">
                <use xlinkHref="#pending" />
            </mask>
            <use fill="#0498B4" fillRule="nonzero" xlinkHref="#pending" />
            <g fill="#0498B4" mask="url(#mask-close)">
                <path d="M0 0h24v24H0z" />
            </g>
        </g>
    </svg>
);

const SAVE_CALL = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <defs>
            <path
                id="a"
                d="M20.7 15.059a.5.5 0 1 1 1 0V21.2a2.8 2.8 0 0 1-2.8 2.8H2.8A2.8 2.8 0 0 1 0 21.2V5.1a2.8 2.8 0 0 1 2.8-2.8h6.141a.5.5 0 0 1 0 1H2.8A1.8 1.8 0 0 0 1 5.1v16.1A1.8 1.8 0 0 0 2.8 23h16.1a1.8 1.8 0 0 0 1.8-1.8v-6.141zM19.254.146l4.6 4.6a.5.5 0 0 1 0 .708l-11.5 11.5A.5.5 0 0 1 12 17.1H7.4a.5.5 0 0 1-.5-.5V12a.5.5 0 0 1 .146-.354l11.5-11.5a.5.5 0 0 1 .708 0zM7.9 12.207V16.1h3.893l11-11L18.9 1.207l-11 11z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="none" fillOpacity="0" d="M0 0h16v16H0z" />
            <mask id="b" fill="#0498B4">
                <use xlinkHref="#a" />
            </mask>
            <use fill="#888888" fillRule="nonzero" xlinkHref="#a" />
            <g fill="#888888" mask="url(#b)">
                <path d="M0 0h16v16H0z" />
            </g>
        </g>
    </svg>
);

const STATFLO_LOGO = (
    <svg
        version="1.1"
        className="stfloCallWidget__headerIcon"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 199.8 252.4"
    >
        <g>
            <rect
                x="67"
                y="180.5"
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -120.3239 129.9519)"
                width="59.5"
                height="59.5"
                fill="#3EC2D9"
            />
            <polygon
                fill="#0098B4"
                points="138.8,210.3 96.7,168.2 138.8,126.2 	"
            />
            <rect
                x="68.2"
                y="13.4"
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.8128 81.8987)"
                fill="#EC227E"
                width="59.5"
                height="59.5"
            />
            <polygon fill="#B71F84" points="55.9,43.1 97.9,85.2 55.9,127.3 	" />
            <polygon
                fill="#253D8F"
                points="96.7,168.2 55.9,127.3 97.9,85.2 138.8,126.2 109.4,155.5"
            />
        </g>
    </svg>
);

const PHONE_ANIMATION_IN_PROGRESS = (
    <svg
        width="425"
        height="57"
        viewBox="0 0 425 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M133.071 37.2009C133.071 35.5886 134.47 34.3201 136.078 34.4383C139.51 34.6905 145.797 35.0357 154.5 35.0357C163.203 35.0357 169.49 34.6905 172.922 34.4383C174.53 34.3201 175.929 35.5886 175.929 37.2009C175.929 41.3359 172.818 44.7744 168.688 44.9842C165.15 45.1642 160.376 45.3213 154.5 45.3213C148.624 45.3213 143.85 45.1642 140.311 44.9842C136.182 44.7744 133.071 41.3359 133.071 37.2009Z"
            fill="#F2F3F7"
        />
        <path
            d="M137.355 34.5269L135.899 15.0952C135.761 13.2479 137.332 11.6785 139.319 11.6785H169.681C171.669 11.6785 173.24 13.2479 173.101 15.0952L171.646 34.5269C168.034 34.7642 162.217 35.0356 154.5 35.0356C146.784 35.0356 140.967 34.7642 137.355 34.5269Z"
            fill="white"
        />
        <path
            d="M137.355 34.5269L135.899 15.0952C135.761 13.2479 137.332 11.6785 139.319 11.6785H169.681C171.669 11.6785 173.24 13.2479 173.101 15.0952L171.646 34.5269C168.034 34.7642 162.217 35.0356 154.5 35.0356C146.784 35.0356 140.967 34.7642 137.355 34.5269Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M133.071 37.2009C133.071 35.5886 134.47 34.3201 136.078 34.4383C139.51 34.6905 145.797 35.0357 154.5 35.0357C163.203 35.0357 169.49 34.6905 172.922 34.4383C174.53 34.3201 175.929 35.5886 175.929 37.2009C175.929 41.3359 172.818 44.7744 168.688 44.9842C165.15 45.1642 160.376 45.3213 154.5 45.3213C148.624 45.3213 143.85 45.1642 140.311 44.9842C136.182 44.7744 133.071 41.3359 133.071 37.2009Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinejoin="round"
        />
        <circle
            cx="200.5"
            cy="28.5"
            r="4"
            fill="#D2D5E3"
            id="circle1"
            className="dot-pulse"
        />
        <circle
            cx="212.5"
            cy="28.5"
            r="4"
            fill="#D2D5E3"
            id="circle2"
            className="dot-pulse"
        />
        <circle
            cx="224.5"
            cy="28.5"
            r="4"
            fill="#D2D5E3"
            id="circle3"
            className="dot-pulse"
        />
        <path
            d="M263.037 9.57283C260.602 7.53234 256.974 7.82564 255.127 10.41C254.634 11.1003 254.049 11.9236 253.039 13.1869C249.565 17.5327 249.565 23.8253 253.058 28.1556C255.637 31.3524 258.341 34.5781 261.364 37.6007C264.386 40.6233 267.612 43.3271 270.809 45.9061C275.139 49.3995 281.432 49.3995 285.777 45.9253C287.125 44.8477 287.966 44.2604 288.68 43.7509C291.176 41.968 291.526 38.471 289.577 36.1024C288.036 34.2306 286.321 32.4449 284.666 30.7018C283.349 29.3133 281.147 29.2226 279.651 30.4173C279.249 30.7386 278.749 31.1622 277.736 32.1118C272.765 29.158 269.753 26.1084 266.853 21.2281C267.814 20.2028 268.238 19.7018 268.562 19.2955C269.754 17.8007 269.666 15.6051 268.269 14.299C266.567 12.7071 264.834 11.0791 263.037 9.57283Z"
            fill="#F2F3F7"
        />
        <path
            d="M263.037 9.57283C260.602 7.53234 256.974 7.82564 255.127 10.41C254.634 11.1003 254.049 11.9236 253.039 13.1869C249.565 17.5327 249.565 23.8253 253.058 28.1556C255.637 31.3524 258.341 34.5781 261.364 37.6007C264.386 40.6233 267.612 43.3271 270.809 45.9061C275.139 49.3995 281.432 49.3995 285.777 45.9253C287.125 44.8477 287.966 44.2604 288.68 43.7509C291.176 41.968 291.526 38.471 289.577 36.1024C288.036 34.2306 286.321 32.4449 284.666 30.7018C283.349 29.3133 281.147 29.2226 279.651 30.4173C279.249 30.7386 278.749 31.1622 277.736 32.1118C272.765 29.158 269.753 26.1084 266.853 21.2281C267.814 20.2028 268.238 19.7018 268.562 19.2955C269.754 17.8007 269.666 15.6051 268.269 14.299C266.567 12.7071 264.834 11.0791 263.037 9.57283Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinejoin="round"
        />
    </svg>
);

const PHONE_ANIMATION_PENDING = (
    <svg
        width="425"
        height="57"
        viewBox="0 0 425 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M133.071 37.2009C133.071 35.5886 134.47 34.3201 136.078 34.4383C139.51 34.6905 145.797 35.0357 154.5 35.0357C163.203 35.0357 169.49 34.6905 172.922 34.4383C174.53 34.3201 175.929 35.5886 175.929 37.2009C175.929 41.3359 172.818 44.7744 168.688 44.9842C165.15 45.1642 160.376 45.3213 154.5 45.3213C148.624 45.3213 143.85 45.1642 140.311 44.9842C136.182 44.7744 133.071 41.3359 133.071 37.2009Z"
            fill="#F2F3F7"
        />
        <path
            d="M137.355 34.5269L135.899 15.0952C135.761 13.2479 137.332 11.6785 139.319 11.6785H169.681C171.669 11.6785 173.24 13.2479 173.101 15.0952L171.646 34.5269C168.034 34.7642 162.217 35.0356 154.5 35.0356C146.784 35.0356 140.967 34.7642 137.355 34.5269Z"
            fill="white"
        />
        <path
            d="M137.355 34.5269L135.899 15.0952C135.761 13.2479 137.332 11.6785 139.319 11.6785H169.681C171.669 11.6785 173.24 13.2479 173.101 15.0952L171.646 34.5269C168.034 34.7642 162.217 35.0356 154.5 35.0356C146.784 35.0356 140.967 34.7642 137.355 34.5269Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M133.071 37.2009C133.071 35.5886 134.47 34.3201 136.078 34.4383C139.51 34.6905 145.797 35.0357 154.5 35.0357C163.203 35.0357 169.49 34.6905 172.922 34.4383C174.53 34.3201 175.929 35.5886 175.929 37.2009C175.929 41.3359 172.818 44.7744 168.688 44.9842C165.15 45.1642 160.376 45.3213 154.5 45.3213C148.624 45.3213 143.85 45.1642 140.311 44.9842C136.182 44.7744 133.071 41.3359 133.071 37.2009Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinejoin="round"
        />
        <circle cx="200.5" cy="28.5" r="4" fill="#D2D5E3" id="circle1" />
        <circle cx="212.5" cy="28.5" r="4" fill="#D2D5E3" id="circle2" />
        <circle cx="224.5" cy="28.5" r="4" fill="#D2D5E3" id="circle3" />
        <path
            d="M263.037 9.57283C260.602 7.53234 256.974 7.82564 255.127 10.41C254.634 11.1003 254.049 11.9236 253.039 13.1869C249.565 17.5327 249.565 23.8253 253.058 28.1556C255.637 31.3524 258.341 34.5781 261.364 37.6007C264.386 40.6233 267.612 43.3271 270.809 45.9061C275.139 49.3995 281.432 49.3995 285.777 45.9253C287.125 44.8477 287.966 44.2604 288.68 43.7509C291.176 41.968 291.526 38.471 289.577 36.1024C288.036 34.2306 286.321 32.4449 284.666 30.7018C283.349 29.3133 281.147 29.2226 279.651 30.4173C279.249 30.7386 278.749 31.1622 277.736 32.1118C272.765 29.158 269.753 26.1084 266.853 21.2281C267.814 20.2028 268.238 19.7018 268.562 19.2955C269.754 17.8007 269.666 15.6051 268.269 14.299C266.567 12.7071 264.834 11.0791 263.037 9.57283Z"
            fill="#F2F3F7"
        />
        <path
            d="M263.037 9.57283C260.602 7.53234 256.974 7.82564 255.127 10.41C254.634 11.1003 254.049 11.9236 253.039 13.1869C249.565 17.5327 249.565 23.8253 253.058 28.1556C255.637 31.3524 258.341 34.5781 261.364 37.6007C264.386 40.6233 267.612 43.3271 270.809 45.9061C275.139 49.3995 281.432 49.3995 285.777 45.9253C287.125 44.8477 287.966 44.2604 288.68 43.7509C291.176 41.968 291.526 38.471 289.577 36.1024C288.036 34.2306 286.321 32.4449 284.666 30.7018C283.349 29.3133 281.147 29.2226 279.651 30.4173C279.249 30.7386 278.749 31.1622 277.736 32.1118C272.765 29.158 269.753 26.1084 266.853 21.2281C267.814 20.2028 268.238 19.7018 268.562 19.2955C269.754 17.8007 269.666 15.6051 268.269 14.299C266.567 12.7071 264.834 11.0791 263.037 9.57283Z"
            stroke="#30374F"
            strokeWidth="2"
            strokeLinejoin="round"
        />
    </svg>
);

const MESSAGE_ICON_PHONE = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask
            id="path-1-outside-1"
            maskUnits="userSpaceOnUse"
            x="-0.518799"
            y="-1"
            width="26"
            height="26"
            fill="black"
        >
            <rect fill="white" x="-0.518799" y="-1" width="26" height="26" />
            <path d="M6.88582 22.9998C7.83782 23.0228 8.64581 22.3526 8.77657 21.4455C8.93118 20.2979 9.21793 19.1712 9.63176 18.0856C9.88626 17.4228 9.72347 16.6756 9.21707 16.1743L7.71674 14.7056C7.55424 14.5466 7.52034 14.3011 7.63388 14.1057C9.36107 11.1322 11.8762 8.67022 14.9138 6.97941C15.1143 6.86782 15.3664 6.90108 15.5294 7.06064L17.0277 8.52734C17.5415 9.02467 18.3037 9.18379 18.9809 8.93457C20.089 8.52983 21.2402 8.2491 22.408 8.09835C23.3279 7.97108 24.0091 7.19562 24 6.28054V2.81171C23.9995 2.30262 23.7804 1.81724 23.3965 1.47418C23.0128 1.13132 22.4997 0.962151 21.9905 1.00713C18.419 1.3784 14.987 2.568 11.9688 4.48196C9.17785 6.21804 6.81155 8.5344 5.03544 11.2705C3.08929 14.2081 1.8742 17.5518 1.48873 21.0237C1.44177 21.5323 1.61603 22.0367 1.96858 22.4129C2.32093 22.7888 2.8187 23.0019 3.34173 22.9998H6.88582Z" />
        </mask>
        <path
            d="M6.88582 22.9998L6.90994 22.0001L6.89788 21.9998H6.88582V22.9998ZM8.77657 21.4455L9.76638 21.5882L9.76761 21.579L8.77657 21.4455ZM9.63176 18.0856L8.69822 17.7271L8.69734 17.7294L9.63176 18.0856ZM9.21707 16.1743L9.92061 15.4636L9.9166 15.4597L9.21707 16.1743ZM7.71674 14.7056L8.41627 13.991L8.41627 13.991L7.71674 14.7056ZM7.63388 14.1057L8.49858 14.6079L7.63388 14.1057ZM14.9138 6.97941L14.4275 6.10564L14.9138 6.97941ZM15.5294 7.06064L16.2289 6.34604L16.2289 6.34603L15.5294 7.06064ZM17.0277 8.52734L16.3282 9.24195L16.3322 9.24584L17.0277 8.52734ZM18.9809 8.93457L18.6378 7.99527L18.6356 7.99609L18.9809 8.93457ZM22.408 8.09835L22.5361 9.09016L22.5451 9.08891L22.408 8.09835ZM24 6.28054L22.9999 6.28054L23 6.29057L24 6.28054ZM24 2.81171L25 2.81171L24.9999 2.81075L24 2.81171ZM23.3965 1.47418L24.0628 0.72851L24.0628 0.72851L23.3965 1.47418ZM21.9905 1.00713L21.9025 0.0110135L21.8948 0.0116942L21.8871 0.012494L21.9905 1.00713ZM11.9688 4.48196L12.497 5.33112L12.5044 5.32647L11.9688 4.48196ZM5.03544 11.2705L5.86914 11.8228L5.87421 11.8149L5.03544 11.2705ZM1.48873 21.0237L0.494836 20.9134L0.493815 20.9226L0.492964 20.9318L1.48873 21.0237ZM1.96858 22.4129L1.23894 23.0967L1.23894 23.0967L1.96858 22.4129ZM3.34173 22.9998L3.34173 21.9998L3.33777 21.9998L3.34173 22.9998ZM6.8617 23.9995C8.29766 24.0342 9.56021 23.0182 9.76634 21.5882L7.7868 21.3028C7.73141 21.6871 7.37799 22.0114 6.90994 22.0001L6.8617 23.9995ZM9.76761 21.579C9.91194 20.5078 10.1796 19.4558 10.5662 18.4418L8.69734 17.7294C8.25622 18.8866 7.95043 20.088 7.78552 21.312L9.76761 21.579ZM10.5653 18.444C10.9632 17.4079 10.7068 16.2419 9.9206 15.4636L8.51355 16.885C8.74019 17.1093 8.80933 17.4377 8.69822 17.7271L10.5653 18.444ZM9.9166 15.4597L8.41627 13.991L7.01722 15.4202L8.51755 16.8889L9.9166 15.4597ZM8.41627 13.991C8.57793 14.1493 8.61684 14.4044 8.49858 14.6079L6.76918 13.6034C6.42384 14.1979 6.53056 14.9439 7.01722 15.4202L8.41627 13.991ZM8.49858 14.6079C10.1343 11.7919 12.5179 9.45747 15.4002 7.85317L14.4275 6.10564C11.2344 7.88297 8.5878 10.4725 6.76918 13.6034L8.49858 14.6079ZM15.4002 7.85317C15.2169 7.95516 14.986 7.92804 14.8299 7.77525L16.2289 6.34603C15.7469 5.87413 15.0117 5.78047 14.4275 6.10564L15.4002 7.85317ZM14.8299 7.77525L16.3282 9.24194L17.7272 7.81273L16.2289 6.34604L14.8299 7.77525ZM16.3322 9.24584C17.1249 10.0132 18.2925 10.2534 19.3263 9.87306L18.6356 7.99609C18.3148 8.11413 17.9581 8.03616 17.7232 7.80883L16.3322 9.24584ZM19.324 9.87387C20.3625 9.49453 21.4417 9.23139 22.5361 9.09012L22.28 7.10658C21.0388 7.2668 19.8154 7.56514 18.6378 7.99528L19.324 9.87387ZM22.5451 9.08891C23.949 8.89466 25.0143 7.703 24.9999 6.27051L23 6.29057C23.004 6.68825 22.7067 7.0475 22.271 7.10778L22.5451 9.08891ZM25 6.28054V2.81171H23V6.28054H25ZM24.9999 2.81075C24.9992 2.01352 24.656 1.25855 24.0628 0.72851L22.7302 2.21985C22.9049 2.37593 22.9997 2.59172 23 2.81267L24.9999 2.81075ZM24.0628 0.72851C23.4726 0.20109 22.6863 -0.0582253 21.9025 0.0110135L22.0785 2.00326C22.3132 1.98253 22.553 2.06154 22.7302 2.21985L24.0628 0.72851ZM21.8871 0.012494C18.1628 0.399651 14.5827 1.64027 11.4333 3.63744L12.5044 5.32647C15.3913 3.49574 18.6753 2.35715 22.0939 2.00177L21.8871 0.012494ZM11.4406 3.63283C8.52612 5.44576 6.05339 7.86574 4.19667 10.726L5.87421 11.8149C7.56972 9.20306 9.82959 6.99031 12.497 5.33108L11.4406 3.63283ZM4.20179 10.7182C2.16854 13.7873 0.897977 17.2823 0.494836 20.9134L2.48262 21.1341C2.85042 17.8213 4.01005 14.629 5.8691 11.8227L4.20179 10.7182ZM0.492964 20.9318C0.419431 21.7283 0.692984 22.5142 1.23894 23.0967L2.69822 21.7291C2.53907 21.5593 2.46411 21.3364 2.48449 21.1156L0.492964 20.9318ZM1.23894 23.0967C1.78411 23.6784 2.549 24.003 3.3457 23.9998L3.33777 21.9998C3.0884 22.0008 2.85774 21.8993 2.69822 21.7291L1.23894 23.0967ZM3.34173 23.9998H6.88582V21.9998H3.34173V23.9998Z"
            fill="white"
            mask="url(#path-1-outside-1)"
        />
    </svg>
);

const MESSAGE_ICON_LIGHTBULB = (
    <svg width="20" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 8.51v1.372h-2.538c.02-.223.038-.448.038-.681 0-.237-.017-.464-.035-.69H20V8.51zM9.352 1.957V0h1.371v1.964a7.73 7.73 0 0 0-1.371-.007zm5.521 1.544l1.57-1.743 1.019.918-1.603 1.777c-.25-.297-.593-.672-.986-.952zm-10.738.952L2.532 2.676l1.019-.918 1.57 1.743c-.392.28-.736.655-.986.952zM2.538 9.882H0V8.51h2.535a8.612 8.612 0 0 0-.035.691c0 .233.018.458.038.681zM12 19H8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm0 2H8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm.25 2h-4.5l1.188.782c.154.138.38.218.615.218h.895c.234 0 .461-.08.615-.218L12.25 23zM16 9.201c0 3.569-3.214 5.983-3.214 8.799h-1.989c-.003-1.858.87-3.389 1.721-4.867C13.279 11.808 14 10.556 14 9.201c0-2.592-2.075-3.772-4.003-3.772C8.072 5.429 6 6.609 6 9.201c0 1.355.721 2.607 1.482 3.932.851 1.478 1.725 3.009 1.72 4.867H7.214C7.214 15.184 4 12.77 4 9.201c0-3.723 2.998-5.772 5.997-5.772C12.998 3.429 16 5.48 16 9.201z"
            fill="#fff"
        />
    </svg>
);

const EDIT_ICON = (
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_2108_7055)">
            <path
                d="M6.15993 3.25439C5.16645 3.29914 4.19199 3.40791 3.24182 3.51782C2.14522 3.64467 1.26824 4.52123 1.14569 5.6183C1.00793 6.85154 0.875 8.12577 0.875 9.42945C0.875 10.7331 1.00793 12.0073 1.14569 13.2406C1.26824 14.3377 2.14522 15.2143 3.24181 15.3411C4.48091 15.4845 5.76131 15.6258 7.07136 15.6258C8.38141 15.6258 9.66179 15.4845 10.9009 15.3411C11.9975 15.2143 12.8745 14.3377 12.997 13.2407C13.0961 12.3535 13.1927 11.4452 13.2391 10.5199"
                stroke="#8790B2"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M11.5526 1.98867L7.34131 6.76714L6.76437 9.48064C6.67154 9.91726 7.12666 10.3304 7.55287 10.1964L10.2532 9.34748L14.603 4.77044C15.3255 4.01024 15.1995 2.73877 14.325 1.96527C13.4709 1.20989 12.2298 1.22037 11.5526 1.98867Z"
                fill="#F2F3F7"
            />
            <path
                d="M11.5526 1.98867L7.34131 6.76714L6.76437 9.48064C6.67154 9.91726 7.12666 10.3304 7.55287 10.1964L10.2532 9.34748L14.603 4.77044C15.3255 4.01024 15.1995 2.73877 14.325 1.96527C13.4709 1.20989 12.2298 1.22037 11.5526 1.98867Z"
                stroke="#8790B2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_2108_7055">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

const LOCK_ICON = (
    <svg
        width="24"
        height="27"
        viewBox="0 0 24 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.71429 11.413H3C1.89543 11.413 1 12.3085 1 13.413V24C1 25.1046 1.89543 26 3 26H21C22.1046 26 23 25.1046 23 24V13.413C23 12.3085 22.1046 11.413 21 11.413H18.2857M5.71429 11.413V7.28571C5.71429 3.81421 8.5285 1 12 1V1C15.4715 1 18.2857 3.81421 18.2857 7.28572V11.413M5.71429 11.413H18.2857"
            stroke="white"
        />
    </svg>
);

const WARNING_ICON = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-alert-circle"
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12" y2="16" />
    </svg>
);

export default {
    PHONE_CALLING,
    PHONE_PENDING,
    SAVE_CALL,
    STATFLO_LOGO,
    PHONE_ANIMATION_IN_PROGRESS,
    PHONE_ANIMATION_PENDING,
    MESSAGE_ICON_PHONE,
    MESSAGE_ICON_LIGHTBULB,
    EDIT_ICON,
    LOCK_ICON,
    WARNING_ICON,
};
